export default "__VITE_ASSET__DIy7CQFs__"